'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var utils_isType_isType = require('../isType/isType.js');
var defineProperty = require('../../defineProperty-3cad0327.js');

function checkMatchingProperties() {
  var baseProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var checkPropertiesList = arguments.length > 1 ? arguments[1] : undefined;
  var propertiesList = utils_isType_isType.isType('object', baseProperties) ? Object.keys(baseProperties) : baseProperties;
  return propertiesList.reduce(function (accValues, key) {
    var hasField = checkPropertiesList.some(function (field) {
      return field === key;
    });

    if (hasField) {
      return _extends._extends_1(defineProperty.defineProperty({}, key, hasField), accValues);
    }

    return accValues;
  }, {});
}

exports.default = checkMatchingProperties;
//# sourceMappingURL=checkMatchingProperties.js.map
